function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#53585C"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M6 1.5V3h12V1.5h1.5V3h3v15.75c0 1.243-1.007 2.25-2.25 2.25H3.75c-1.243 0-2.25-1.007-2.25-2.25V3h3V1.5H6zm-1.5 3H3v14.25c0 .414.336.75.75.75h16.5c.414 0 .75-.336.75-.75V4.5h-1.5v2.25H18V4.5H6v2.25H4.5V4.5zm4.5 9V18H4.5v-4.5H9zm5.25 0V18h-4.5v-4.5h4.5zM7.5 15H6v1.5h1.5V15zm5.25 0h-1.5v1.5h1.5V15zM9 8.25v4.5H4.5v-4.5H9zm5.25 0v4.5h-4.5v-4.5h4.5zm5.25 0v4.5H15v-4.5h4.5zm-12 1.5H6v1.5h1.5v-1.5zm5.25 0h-1.5v1.5h1.5v-1.5zm5.25 0h-1.5v1.5H18v-1.5z",
  transform: "translate(-31 -360) translate(19 322) translate(12 38)"
})))));

var SvgDate = function SvgDate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/date.3fcc8d20.svg";
export { ForwardRef as ReactComponent };